module.exports = "<div class=\"home-button interactive\" routerLink=\"/\">\r\n  <i class=\"kng-icon kng-icon-home\"></i>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/components/home-button/home-button.component.html
// module id = ../../../../../src/app/components/home-button/home-button.component.html
// module chunks = main